// extracted by mini-css-extract-plugin
export default {"link":"HeadPage_link__lXOAo","lastLink":"HeadPage_lastLink__GecU4"};